import { NgModule } from '@angular/core';

import { ProgressBarSharedComponent } from './progress-bar.component';

@NgModule({
    declarations: [
        ProgressBarSharedComponent
    ],
    exports: [
        ProgressBarSharedComponent
    ]
})

export class ProgressBarSharedModule {}
